import { useRef, useEffect, useState } from 'react';

/**
 * Detects if text content overflows its container.
 * @param content - The text content to monitor
 * @returns Tuple of [ref, isOverflowing]
 */
export const useOverflowDetection = <T extends HTMLElement = HTMLElement>(content: string) => {
  const ref = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (ref.current) {
      setIsOverflowing(ref.current.scrollWidth > ref.current.clientWidth);
    }
  }, [content]);

  return [ref, isOverflowing] as const;
};
